<script>
export default {
  props: {
    reportText: {
      type: [String, Array],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Raw Report',
    },
  },
}
</script>
